import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.FormLink,
  title: 'Form Link',
  category: ComponentCategory.FormControls,
};
